import axios from '../request'

// 获取数据字典
export function getDict(type): Promise<any> {
  return axios.get('/api/v1/dict_detail/options', {
    params: { dictinary_code: type }
  })
}
// 获取上传签名
export function getSignUrl(filename: any): Promise<any> {
  return axios.post(`/api/v1/common/upload/sign_url?filename=${filename}&timeout=1200`, {})
}

// 上传接口
export function uploadFile(uploadUrl: string, arrayBuf: ArrayBuffer) {
  if (uploadUrl == '') {
    console.log('no uploadUrl: ' + uploadUrl)
    return
  }

  return axios({
    method: 'put',
    url: uploadUrl,
    withCredentials: false,
    headers: {
      'Content-Type': ''
    },
    data: arrayBuf
  })
}

// 自定义mcp聊天上传接口
export function uploadCustomMcpFile(formData: FormData) {
  return axios.post('/api/v1/auto_mcp/upload_file', formData);
}

/**
 * 通用批量文件上传接口
 * 参数：files（多个文件同名 files 字段）、source（业务来源，默认 general）
 * 响应：data.files[].{ success, file_name, file_url, file_id, size, file_type, format, error }
 */
export function uploadCommonFile(formData: FormData): Promise<any> {
  // source 统一传 general
  formData.append('source', 'general')
  return axios.post('/api/v1/common/upload/batch', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 获取数据字典
export function aiIconGenerateApi(data): Promise<any> {
  return axios.post('/api/v1/ai/icon_generate', data)
}

export type imageContentCheckApiPropsType = {
  file_name: string
  data: string
}

// // 图片内容合规校验接口
// export function imageContentCheckApi(data: imageContentCheckApiPropsType): Promise<any> {
//   return axios.post('/api/v1/ai/image_check', data)
// }

// 获取用户权限list
export function getPermissionsApi(): Promise<any> {
  return axios.get('/api/v1/permission/allow_codes', {
    headers: {
      Token: localStorage.getItem('lenovo-token') || ''
    }
  })
}
